import React from 'react';
import {
  Page, Image, View, Document, StyleSheet
} from '@react-pdf/renderer';

/*
react-pdf 4 lays an Image out at its intrinsic pixel size, where the previous renderer
shrank it to the page. The preview pages are canvas exports a few thousand pixels tall,
so with no box to fit into they overflow the page and the renderer discards them with a
"can't wrap between pages" warning. objectFit keeps the aspect ratio inside that box.
*/
const styles = StyleSheet.create({
  page: {
    padding: 0,
  },
  container: {
    width: '100%',
    height: '100%',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
});

interface Props {
  readonly previewPages: string[];
}

function SketchPrintPdf({ previewPages }: Props): JSX.Element {
  return (
    <Document>
      {previewPages.map((previewPage, index) => (
        // The pages are positional and carry no identity of their own.
        // eslint-disable-next-line react/no-array-index-key
        <Page key={index} size="A4" style={styles.page}>
          <View style={styles.container}>
            <Image src={previewPage} style={styles.image} />
          </View>
        </Page>
      ))}
    </Document>
  );
}

export default SketchPrintPdf;
